/**
 * Created by hp on 2017/6/9.
 */
import React, {Component} from 'react';
import leftPad from 'left-pad'
import { connect } from 'react-redux'
import {renderMoney} from '../../utils';

import '../../styles/lecture/LectureLimitPrice.css';

class ChannelLimitPrice extends Component {
    constructor(props) {
        super(props);
        const channel = props.channel
        const groupBuy = props.groupBuy
        this.limitTimeStamp = props.type === 'channelGroupBuy' ? groupBuy.deadline : channel.promoprice.deadline_timestamp;
        let getDuration = () => (this.limitTimeStamp - parseInt(new Date().getTime() / 1000, 10));
        this.state = {
            duration: getDuration()
        };

        this.interval = setInterval(() => {
            let duration = getDuration();
            this.setState({duration});
        }, 100);
    }

    componentWillReceiveProps (props) {
        this.limitTimeStamp = props.type === 'channelGroupBuy' ? props.groupBuy.deadline : props.channel.promoprice.deadline_timestamp;
    }

    componentWillUnmount (){
        clearInterval(this.interval)
    }

    render() {
        if (this.state.duration <= 0) {
            clearInterval(this.interval)
            return null
        }
        const { type, channel, groupBuy } = this.props
        let money = this.props.channel.money
        let limitMoney = type === 'channelGroupBuy' ? groupBuy.price : channel.promoprice.price
        let tmp = this.state.duration;

        let ss = tmp % 60;
        tmp = (tmp - ss) / 60;

        let mm = tmp % 60;
        tmp = (tmp - mm) / 60;

        let dd = (tmp - tmp % 24) / 24;
        let hh = tmp % 24;

        // 分离小数点
        limitMoney = renderMoney(limitMoney).split(".");
        let moneyMain = limitMoney[0];
        let moneySub = limitMoney[1];

        return (
            <div className="lecture-limit-price">
                <div className="lecture-limit-price__left">
                    <div className="flash-sale-price weui-flex">
                        <span className="flash-sale-num">
                            <span className="flash-sale-num-text">￥</span>
                            <span className="flash-sale-num-main">{moneyMain}</span>
                            <span className="flash-sale-num-point">.</span>
                            <span className="flash-sale-num-sub">
                                {moneySub}
                                <span className="flash-sale-num-sub-text hide">限时{type === 'channelGroupBuy' ? '拼团' : '特价'}</span>
                            </span>
                        </span>
                        <div className="weui-flex__item text-left flash-sale-original">
                            <div className="original-cost">￥{renderMoney(money)}</div>
                            <span className="original-tips">限时{type === 'channelGroupBuy' ? '拼团' : '特价'}</span>
                        </div>
                    </div>
                </div>

                <div className="lecture-limit-price__right flash-sale-countdown text-center">
                    <p className="flash-sale-text">距离{type === 'channelGroupBuy' ? '拼团' : '特价'}结束仅剩</p>
                    <div className="time-item flash-sale-time">
                        {dd > 0 &&
                        <span className="flash-sale-time-day">{dd}天</span>
                        }
                        <span className="flash-sale-time-item">{leftPad(hh, 2, '0')}</span>
                        <span className="flash-sale-time-mh">:</span>
                        <span className="flash-sale-time-item">{leftPad(mm, 2, '0')}</span>
                        <span className="flash-sale-time-mh">:</span>
                        <span className="flash-sale-time-item">{leftPad(ss, 2, '0')}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect()(ChannelLimitPrice)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelLimitPrice.js